import { BOOKING_MODAL_VISIBLE, UPGRADE_STUDIO_PLAN_PRESSED_SUCCESS } from '../../Bookings/actionTypes';
import { DASHBOARD_BLOG_CARD_PRESSED } from '../../SummaryDashboard/actionTypes';
import { SHOW_CONTINUE_ON_APP_SCREEN } from '../../WeightTarget/actionTypes';
import { types } from './uiActions';

export interface IUiReducerState {
  loading: boolean;
  bookingsModal: boolean;
  workoutPartnersModalVisible: boolean;
  title: string;
  privacySettingsModalVisible: boolean;
  mealModalVisible: boolean;
  nutritionStepsVisible: boolean;
  foodPreferencesModalVisible: boolean;
  dieticianModalVisible: boolean;
  shoppingListEditModalVisible: boolean;
  workoutHistoryModalVisible: boolean;
  privacyRemoveConfirmationModalVisible: boolean;
  welcomeDashboardModalVisible: boolean;
  toast: any;
  workoutProgramSelectModalVisible: boolean;
  statsGraphModalVisible: boolean;
  scanReportModalVisible: boolean;
  firstVideoModalVisible: boolean;
  heartRateMonitorModalVisible: boolean;
  heartRateMonitorModalStudioVisible: boolean;
  screenMirroringModalVisible: boolean;
  trackingOnboardingModalVisible: boolean;
  userProfileModalVisible: boolean;
  onboardingInviteModalVisible: boolean;
  bodyscanModalVisible: boolean;
  bookingCompleteOnboardingVisible: boolean;
  skillLevelSelectModalVisible: boolean;
  weightTargetModalVisible: boolean;
  removeTargetModalVisible: boolean;
  blogPostModalOpen: boolean;
  postOpenInBlogPostModal: any;
  plansDetailScreenVisible: boolean;
  strengthAssessmentModalVisible: boolean;
  webviewModalOpen: boolean;
  webviewModalUrl?: string;
  continueOnAppScreenVisible: boolean;
}

export const initialState: IUiReducerState = {
  loading: false,
  bookingsModal: false,
  workoutPartnersModalVisible: false,
  title: '',
  privacySettingsModalVisible: false,
  mealModalVisible: false,
  nutritionStepsVisible: false,
  foodPreferencesModalVisible: false,
  dieticianModalVisible: false,
  shoppingListEditModalVisible: false,
  workoutHistoryModalVisible: false,
  privacyRemoveConfirmationModalVisible: false,
  welcomeDashboardModalVisible: false,
  toast: null,
  workoutProgramSelectModalVisible: false,
  statsGraphModalVisible: false,
  scanReportModalVisible: false,
  firstVideoModalVisible: false,
  heartRateMonitorModalVisible: false,
  heartRateMonitorModalStudioVisible: false,
  screenMirroringModalVisible: false,
  trackingOnboardingModalVisible: false,
  userProfileModalVisible: false,
  onboardingInviteModalVisible: false,
  bodyscanModalVisible: false,
  bookingCompleteOnboardingVisible: false,
  skillLevelSelectModalVisible: false,
  weightTargetModalVisible: false,
  removeTargetModalVisible: false,
  blogPostModalOpen: false,
  postOpenInBlogPostModal: null,
  plansDetailScreenVisible: false,
  strengthAssessmentModalVisible: false,
  webviewModalOpen: false,
  webviewModalUrl: undefined,
  continueOnAppScreenVisible: false,
};

export default (state: IUiReducerState = initialState, action): IUiReducerState => {
  switch (action.type) {
    case 'ui/loading/hide':
      return {
        ...state,
        loading: false,
      };
    case 'ui/loading/show':
      return {
        ...state,
        loading: true,
      };
    case 'ui/toast/show':
      return {
        ...initialState,
        toast: action.toast,
      };
    case 'ui/toast/hide':
      return {
        ...initialState,
        toast: null,
      };
    case BOOKING_MODAL_VISIBLE:
      let toast = state.toast;
      if (action.visible) {
        toast = null;
      }
      return {
        ...initialState,
        toast,
      };
    case 'ui/modal/closeAll':
      return {
        ...initialState,
      };
    case 'ui/modal/workoutPartners':
      return {
        ...initialState,
        workoutPartnersModalVisible: action.visible,
      };
    case 'ui/modal/plansDetailScreenVisible':
      return {
        ...initialState,
        plansDetailScreenVisible: action.visible,
      };
    case 'ui/modal/welcomeDashboardModalVisible':
      return {
        ...initialState,
        welcomeDashboardModalVisible: action.visible,
      };
    case 'ui/title':
      return {
        ...state,
        title: action.title,
      };
    case 'ui/modal/privacySettingModalVisible':
      return {
        ...initialState,
        privacySettingsModalVisible: action.visible,
      };
    case 'ui/modal/mealModal':
      return {
        ...initialState,
        mealModalVisible: action.visible,
      };
    case 'ui/modal/nutritionStrepsModal':
      return {
        ...initialState,
        nutritionStepsVisible: action.visible,
      };
    case 'ui/modal/foodPreferencesModal':
      return {
        ...initialState,
        foodPreferencesModalVisible: action.visible,
      };
    case 'ui/modal/dieticianModal':
      return {
        ...initialState,
        dieticianModalVisible: action.visible,
      };
    case 'ui/modal/workoutHistoryModal':
      return {
        ...initialState,
        workoutHistoryModalVisible: action.visible,
      };
    case 'ui/modal/privacyRemoveConfirmationModalVisible':
      return {
        ...initialState,
        privacyRemoveConfirmationModalVisible: action.visible,
      };
    case 'ui/modal/workoutProgramSelectModalVisible':
      return {
        ...initialState,
        workoutProgramSelectModalVisible: action.visible,
      };
    case 'ui/modal/statsGraphModalVisible':
      return {
        ...initialState,
        statsGraphModalVisible: action.visible,
      };
    case 'ui/modal/scanReportModalVisible':
      return {
        ...initialState,
        scanReportModalVisible: action.visible,
      };
    case 'ui/modal/firstVideoModalVisible':
      return {
        ...initialState,
        firstVideoModalVisible: action.visible,
      };
    case 'ui/modal/shoppingListEditModalVisible':
      return {
        ...initialState,
        shoppingListEditModalVisible: action.visible,
      };
    case 'ui/modal/heartRateMonitorModalVisible':
      return {
        ...initialState,
        heartRateMonitorModalVisible: action.visible,
      };
    case 'ui/modal/heartRateMonitorModalStudioVisible':
      return {
        ...initialState,
        heartRateMonitorModalStudioVisible: action.visible,
      };
    case 'ui/modal/screenMirroringModalVisible':
      return {
        ...initialState,
        screenMirroringModalVisible: action.visible,
      };
    case 'ui/modal/trackingOnboardingModalVisible':
      return {
        ...initialState,
        trackingOnboardingModalVisible: action.visible,
      };
    case 'ui/modal/userProfileModalVisible':
      return {
        ...initialState,
        userProfileModalVisible: action.visible,
      };
    case 'ui/modal/onboardingInviteModal':
      return {
        ...initialState,
        onboardingInviteModalVisible: action.visible,
      };
    case 'ui/modal/bodyscanModal':
      return {
        ...initialState,
        bodyscanModalVisible: action.visible,
      };
    case 'ui/modal/bookingCompleteOnboardingModal':
      return {
        ...initialState,
        bookingCompleteOnboardingVisible: action.visible,
      };
    case 'ui/modal/skillLevelSelectModal':
      return {
        ...initialState,
        skillLevelSelectModalVisible: action.visible,
      };
    case 'ui/modal/strengthAssessment':
      return {
        ...initialState,
        strengthAssessmentModalVisible: action.visible,
      };
    case types.WEIGHT_TARGET_MODAL:
      return {
        ...initialState,
        weightTargetModalVisible: action.visible,
      };
    case types.REMOVE_TARGET_MODAL:
      return {
        ...initialState,
        removeTargetModalVisible: action.visible,
      };
    case DASHBOARD_BLOG_CARD_PRESSED:
      return {
        ...initialState,
        blogPostModalOpen: true,
        postOpenInBlogPostModal: action.payload.post,
      };
    case types.BLOG_POST_MODAL_CLOSED:
      return {
        ...initialState,
        blogPostModalOpen: false,
        postOpenInBlogPostModal: null,
      };
    case UPGRADE_STUDIO_PLAN_PRESSED_SUCCESS:
      if (!action.payload.accountSelfManagementLink) {
        break;
      }
      return {
        ...initialState,
        webviewModalOpen: true,
        webviewModalUrl: action.payload.accountSelfManagementLink,
      };
    case types.CLOSE_WEBVIEW_MODAL_PRESSED:
      return {
        ...initialState,
        webviewModalOpen: false,
        webviewModalUrl: undefined,
      };
    case types.OPEN_WEBVIEW_MODAL:
      return {
        ...initialState,
        webviewModalOpen: true,
        webviewModalUrl: action.payload.webviewModalUrl,
      };
    case SHOW_CONTINUE_ON_APP_SCREEN:
      return {
        ...state,
        continueOnAppScreenVisible: action.payload,
      };
    default:
      return state;
  }
};

const isLoading = (state: { ui: IUiReducerState }) => state.ui.loading;

export const Store = ({
  isLoading,
  toast: null,
  bookingsModal: false,
  workoutPartnersModalVisible: false,
  privacyRemoveConfirmationModal: false,
});
